// src/axios.js
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://9bpkzpi2mf.execute-api.eu-north-1.amazonaws.com/', // Your base API URL
  //baseURL: 'https://f01ef893-9c27-44d5-8cf0-6eccee0e797f.mock.pstmn.io'
});

export default instance;
